import type {
  WorkspaceIntroSection,
  WorkspaceIntroStep,
} from '../../../shared/ui/common/WorkspaceIntroCard';
import type {
  WorkspaceSpotlightTourDetail,
  WorkspaceSpotlightTourStep,
} from '../../../shared/ui/common/WorkspaceSpotlightTour';

export interface QuickFillGuideContentArgs {
  readonly visibleColumnCount: number;
  readonly rowCount: number;
  readonly workflowMode: string;
  readonly isTableLoading: boolean;
}

type TourTargetRef = NonNullable<WorkspaceSpotlightTourStep['targetRef']>;

export interface QuickFillTourRefs {
  readonly actionBarRef: TourTargetRef;
  readonly pageGuideRef: TourTargetRef;
  readonly recoveryControlsRef: TourTargetRef;
  readonly navigationDockRef: TourTargetRef;
  readonly filterTriggerRef: TourTargetRef;
  readonly filterPopoverRef: TourTargetRef;
  readonly autoFillControlsRef: TourTargetRef;
  readonly manageColumnsRef: TourTargetRef;
  readonly findReplaceRef: TourTargetRef;
  readonly rowModeToggleRef: TourTargetRef;
  readonly modelSelectRef: TourTargetRef;
  readonly csvToolsRef: TourTargetRef;
  readonly utilityToolsRef: TourTargetRef;
  readonly tableViewportRef: TourTargetRef;
  readonly propertyPanelRef: TourTargetRef;
  readonly propertySearchRef: TourTargetRef;
  readonly valuePanelRef: TourTargetRef;
  readonly valueSearchRef: TourTargetRef;
  readonly autoFillPreviewDialogRef: TourTargetRef;
  readonly saveReviewDialogRef: TourTargetRef;
  readonly findReplaceDialogRef: TourTargetRef;
  readonly footerActionsRef: TourTargetRef;
}

export interface QuickFillTourContentArgs {
  readonly rowCount: number;
  readonly refs: QuickFillTourRefs;
  readonly hostRibbonAvailable?: boolean;
}

export const section = (title: string, bullets: string[]): WorkspaceIntroSection => ({
  title,
  bullets,
});

export const step = (label: string, goal: string, checks?: string[]): WorkspaceIntroStep => ({
  label,
  goal,
  checks,
});

export const detail = (
  label: string,
  bullets: string[],
  tone: WorkspaceSpotlightTourDetail['tone'] = 'default'
): WorkspaceSpotlightTourDetail => ({
  label,
  bullets,
  tone,
});

export const spotlightStep = (
  base: Omit<WorkspaceSpotlightTourStep, 'targetRef' | 'fallbackRect'>,
  targetRef: TourTargetRef,
  fallbackRect: NonNullable<WorkspaceSpotlightTourStep['fallbackRect']>
): WorkspaceSpotlightTourStep => ({
  ...base,
  targetRef,
  fallbackRect,
});
